import {Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export const AdminDashboardView: React.FC = () => {
    const {t} = useTranslation();
    return (
        <Stack paddingX="1.5rem" paddingTop="1.5rem" paddingBottom="0.5rem">
            <Typography sx={{fontSize: "1.375rem", lineHeight: "1.75rem", fontWeight: "500", color: "#4d5175"}}>
                {t("admin.dashboard_view.title")}
            </Typography>
        </Stack>
    );
};
